import { customTheme } from 'theme';

import { SideNavMenuItemStyles, SideNavStyles } from './types';

export const defaultStyles: SideNavStyles = {
  menu: {
    w: 'full',
    //overflow: 'scroll',
    h: 'full',
    allowMultiple: true,
    //p: 2,
  },
  menuItem: {
    //py: 3,
    justifyContent: 'space-between',
    color: customTheme.colors.gray['300'],
    fontSize: '15px',
    _hover: { color: 'primary', cursor: 'pointer' },
    _focus: {},
  },
  selectedSecondary: {
    bg: 'selectedSideNavMenuBg',
    //borderRight: '4px solid',
    //borderColor: 'primary',
    color: 'primary',
    pr: 4,
    borderRadius: 6,
  },
  selectedPrimary: {
    color: 'primary',
  },
  componentWrapper: {
    overflow: 'auto',
    w: 'full',
    maxW: 'full',
    flex: 1,
    h: 'full',
  },
};

export const menuItemStyles: SideNavMenuItemStyles = {
  titleWrapper: {
    spacing: 4,
  },
  title: {
    fontSize: 'md',
  },
  iconStyles: {
    boxSize: 8,
    mr: 4,
  },
};

export const sideNavCategoryHeaderStyles = {
  menuItem: {
    fontWeight: 600,
    cursor: 'default',
    color: customTheme.colors.gray['300'],
    _hover: { color: customTheme.colors.gray['300'] },
  },
  menu: { index: undefined, defaultIndex: [0] },
};
